import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuxiliarService } from './../../auxiliar.service';
import { AuthService } from './../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CargasService {

  server: string = '';
  token: string = '';

  constructor(private auth: AuthService, private httpClient: HttpClient, private auxiliarService: AuxiliarService) {
    this.server = this.auxiliarService.getServidor()+"/api/cargas";
    this.token = this.auth.getToken();
  }

  newCarga(matricula: string, nAlbaran: string, material: string, pesoBascula: string, observaciones: string, imageName: string, scaleId: string){
    const formData = new FormData();
    formData.append('matricula', matricula);
    formData.append('nAlbaran', nAlbaran);
    formData.append('material', material);
    formData.append('pesoBascula', pesoBascula);
    formData.append('observaciones', observaciones);
    formData.append('imageName', imageName);
    formData.append('scale', scaleId);
    return this.httpClient.post(this.server, formData);
  }

}
